export const TAX_FORECAST_BASE_URL = '/integration.module/income.tax.forecast';
